import Component from '../abstracts/Component';

export default class SelectComponent extends Component {

  get SELECTORS() {
    return {
      main: 'select',
      withInput: '[data-with-input]'
    };
  }

  get BASE_CONF() {
    return {
      minimumResultsForSearch: Infinity,
      maximumSelectionLength: 10
    }
  }

  //bottom value needed to put the input at the bottom of the select options
  get WITH_INPUT_CONF() {
    return {
      maximumSelectionLength: 10,
      tags: true,
      inputPosition: 'bottom'
    }
  }

  constructor() {
    super();
  }

  initSelect() {
    const elements = document.querySelectorAll(this.SELECTORS.main);
    elements.forEach(el => {
      let data = el.dataset.withInput ? this.WITH_INPUT_CONF : this.BASE_CONF;
      if (el.dataset.selectPlaceholder) data['placeholder'] = el.dataset.selectPlaceholder;
      $(el).select2(data);
    });

  }

  initSelectMobile() {
    const elements = document.querySelectorAll(this.SELECTORS.main);
    elements.forEach(el => {
      let data = el.dataset.withInput ? this.WITH_INPUT_CONF : this.BASE_CONF;
      if (el.dataset.selectPlaceholder) data['placeholder'] = el.dataset.selectPlaceholder;
      else el.options[0].setAttribute('selected', 'selected');
    });

  }

  loadAndInit() {
    this.moduleLoader.loadSelect2(
      (module) => {
        this.initSelect();
      },
      (error) => {
        console.log("failed to load select2 ", error.stack);
      }
    );
  }

  render() {
    if (this.$matchMedia(null,'sm')) {
      this.loadAndInit();
    } else if(this.$matchMedia('sm', null)) {

      this.moduleLoader.loadSelect2(
        (module) => {

          const elements = document.querySelectorAll(this.SELECTORS.withInput);
          elements.forEach(el => {
            let data = this.WITH_INPUT_CONF;
            if (el.dataset.selectPlaceholder) data['placeholder'] = el.dataset.selectPlaceholder;
            $(el).select2(data);
          });

        },
        (error) => {
          console.log("failed to load select2 ", error.stack);
        }
      );


    } else {
      this.initSelectMobile();
    }

  }
}

